// export function submittotelroom(params) {
//     const { ...restParams } = params;
//     // console.log(params);
//     const queryParams = new URLSearchParams({
//       ...restParams
//     }).toString();
  
//     // 创建一个全局唯一的回调函数名
//     const callbackName = `jsonp_${Date.now()}`;
  
//     // 创建一个script标签
//     const script = document.createElement('script');
    
//     // 设置script标签的src属性，包含回调函数名和请求参数
//     script.src = `http://tg2.tetuijiudian.com/shuihotel/index.php/agent/addorder?${queryParams}&callback=${callbackName}`;
  
//     // 将script标签添加到页面中
//     document.body.appendChild(script);
  
//     // 创建一个Promise，用于处理返回的值
//     return new Promise((resolve, reject) => {
//       // 创建全局回调函数
//       window[callbackName] = function(response) {
//         // 处理返回的数据

       
//         // 移除script标签
//         document.body.removeChild(script);
  
//         // 清除全局回调函数
//         delete window[callbackName];
  
//         // 将返回的数据传递给Promise的resolve函数
//         resolve(response);
//       };
//     });
// }
export function submittotelroom(params) {
  const { ...restParams } = params;
  const queryParams = $.param(restParams);
  
  return new Promise((resolve, reject) => {
    const callbackName = `jsonp_${Date.now()}`;
    
    // 使用 $.ajax 方法发送 JSONP 请求
    $.ajax({
      url: 'https://admin.xiaodianjia.cn/api/book/book_order/addBrowseOrder',
      type: 'POST',
      data: restParams, // Send the parameters as the request body
      success: function(response) {
        // 处理返回的数据
        
        resolve(response);
      },
      error: function(error) {
        reject(error);
      }
    });
  });
}


export function getroom(params) {
  const { ...restParams } = params;
  // console.log(params);
  const queryParams = new URLSearchParams({
    ...restParams
  }).toString();

  // 创建一个全局唯一的回调函数名
  const callbackName = `jsonp_${Date.now()}`;

  // 创建一个script标签
  const script = document.createElement('script');
  
  // 设置script标签的src属性，包含回调函数名和请求参数
  script.src = `http://81.70.247.104/e/json.php?${queryParams}&callback=${callbackName}`;

  // 将script标签添加到页面中
  document.body.appendChild(script);

  // 创建一个Promise，用于处理返回的值
  return new Promise((resolve, reject) => {
    // 创建全局回调函数
    window[callbackName] = function(response) {
      // 处理返回的数据

     
      // 移除script标签
      document.body.removeChild(script);

      // 清除全局回调函数
      delete window[callbackName];

      // 将返回的数据传递给Promise的resolve函数
      resolve(response);
    };
  });
}